export default "__VITE_ASSET__EL6ThxpT__"